export default __webpack_public_path__ + "static/media/bg_1.7d1d3c91.png";